import {reactive} from "vue";

const NO_DATA = '-';
const SUFFIX_PERCENT = '%'
export const UNIT_BEARING = 't/㎡'

function format(v, options){
  const _options = Object.assign({
    isInteger: false,
    isLocale: false,
    fixed: 0,
    divide: 0,
    suffix: '',
    multiply: 0,
  }, options);

  const {fixed, isLocale, isInteger, divide, suffix, multiply} = _options;
  const handlers = [];

  handlers[0] = function(v){
    return divide > 0 ? (v / divide) : v;
  }

  handlers[1] = function(v){
    return multiply > 0 ? (v * multiply) : v;
  }

  handlers[2] = function(v){
    return isInteger ? parseInt(v) : v;
  }

  handlers[3] = function(v){
    return fixed > 0 ? v.toFixed(fixed) : v;
  }

  handlers[4] = function(v){
    if(isLocale){
      // 字符串处理
      if(typeof v === 'string'){
        const iStart = v.indexOf(".");
        return parseInt(v).toLocaleString() + v.substring(iStart);
      }
      // 数字处理
      return v.toLocaleString();
    }else{
      return v;
    }
  }

  handlers[5] = function (v){
    return suffix ? v + suffix : v;
  }

  return handlers.reduce((_v, handler) => handler(_v), v)
}

function undefinedOrNull(value){
  return undefined === value || null === value || isNaN(value);
}

function numberFormat(value, options){
  return undefinedOrNull(value) ? NO_DATA : format(Number(value), options);
}

export function isEmptyNumber(value){
  return undefinedOrNull(value) || 0 === value;
}

export function emptyArray(value){
  return undefined === value || null === value || 0 === value.length;
}

export function notEmptyArray(value){
  return !emptyArray(value);
}

// 处理空置率
export function vacancyRate(value){
  return numberFormat(value, {fixed: 2, multiply: 100, suffix: SUFFIX_PERCENT});
}
export function vacancyRateWithSuffix(value){
  return numberFormat(value, {fixed: 2, suffix: SUFFIX_PERCENT});
}
export function vacancyRateMultiply(value){
  return numberFormat(value, {fixed: 2, multiply: 100});
}
export function vacancyRateNoSuffix(value){
  return numberFormat(value, {fixed: 2});
}

export function vacancyRateNoSuffixMultiply(value){
  return numberFormat(value, {fixed: 2});
}

export function vacancyRateNoMultiply(value){
  return numberFormat(value, {fixed: 2, suffix: SUFFIX_PERCENT});
}

// 处理有效租金
export function effectiveRent(value){
  return numberFormat(value, {fixed: 2});
}

// 处理土地面积
export function formatArea(value){
  return numberFormat(value, {fixed: 2, isInteger: true});
}

// 土地面积  保留两位小数，也要存在千分位
// 土地成交均价  保留两位小数，也要存在千分位
export function landAreaFormat(value){
  return numberFormat(value, {fixed: 2, isLocale: true});
}

// 柱状图占比计算
export function chartPieRate(value, total){
  return numberFormat(value, {fixed: 2, multiply: 100, divide: total, suffix: SUFFIX_PERCENT})
}

// 处理同比环比
export function ymRate(value){
  return numberFormat(value, {fixed: 2, multiply: 100, suffix: SUFFIX_PERCENT})
}

export function toPercent(num) {
  console.log(num);
  
  return (Number(num.toFixed(2)) * 100).toFixed(2) + '%';
}

export function normalRate(value){
  return numberFormat(value, {fixed: 2, suffix: SUFFIX_PERCENT})
}

// 租户面积/仓库面积  所有的面积都是没小数，分千分位
export function warehouseArea(value){
  return numberFormat(value, {isInteger: true, isLocale: true})
}
// 城市群预计增量/存量 尝试 w/10w/100w找出最佳 预计增量两位小数，分千分位
export function aggWarehouseArea(value){
  return numberFormat(value, {fixed: 2, divide: 10000, isLocale: true });
}

export function aggWarehouseAreaNoDivide(value){
  return numberFormat(value, {isInteger: true, isLocale: true });
}

export function aggNumWarehouseArea(value){
  return numberFormat(value, {isInteger: true, divide: 10000 });
}

// 仓库租金/租赁/预估租金 两位数 分千分号
export function rentPriceFormat(value){
  return numberFormat(value, {fixed: 2, isLocale: true})
}

// 土地面积：小数点两位数，千分号
export function landUseAreaFormat(value){
  return numberFormat(value, {fixed: 2, isLocale: true})
}

// 图表
// 柱状图中要保存图标 图标的色块不一样
// 标题不需要说明，加粗，带单位数字之后
// 预估有效租金单位放到数据轴
// 同比/环比
// 小角标 没有就不显示


export const keys = reactive({
  existingInventoryMetric: {str: '现有存量', unit: '㎡', tipText: "建成面积（包含本季度增量）", format: warehouseArea},
  quarterlyIncreaseMetric: {str: '本季度增量', unit: '㎡', tipText: "本季度建成面积", format: warehouseArea},
  netAbsorptionMetric: {str: '净吸纳量', unit: '㎡', hiddenCircle: true, hiddenSame: true, format: warehouseArea},
  vacancyRateMetric: {str: '空置率', format:vacancyRate},
  estimatedEffectiveRentMetric: {str: '预估有效租金', unit: '元/㎡·月', tipText: "折算免租期、装修期后的租金", format: rentPriceFormat},
  estimatedIncrementMetric: {str: '预计增量', unit: '㎡', tipText: "预计投入市场的面积", format: warehouseArea},
  // estimatedSalesCycleMetric: { str: '预计去化周期', unit: '月', tipText: "去化10万平所需时间" },
})





